// Reparto de dominios en producción: la web en owtli.com y el panel (/admin y /login) en admin.owtli.com. El edge
// (src/seo/edge-handler.ts) lo aplica en cada carga; esto lo aplica en la navegación dentro de la SPA, que no pasa por el
// edge. La sesión se guarda por dominio, así que el acceso y el panel tienen que estar siempre en el mismo.

export const SITE_ORIGIN = 'https://owtli.com'
export const ADMIN_ORIGIN = 'https://admin.owtli.com'

const esRutaDePanel = (pathname: string) => /^\/(admin|login)(\/|$)/.test(pathname)

/** URL completa a la que hay que ir si la ruta no es de este dominio; null si estamos donde toca (o en local). */
export function destinoPorDominio(hostname: string, pathname: string, resto = ''): string | null {
  const panel = esRutaDePanel(pathname)
  if (hostname === new URL(ADMIN_ORIGIN).hostname && !panel) return `${SITE_ORIGIN}${pathname}${resto}`
  if (hostname === new URL(SITE_ORIGIN).hostname && panel) return `${ADMIN_ORIGIN}${pathname}${resto}`
  return null
}

/** Enlace a una página de la web desde el panel: absoluto en admin.owtli.com, relativo en local. */
export function urlWeb(path: string): string {
  return typeof window !== 'undefined' && window.location.hostname === new URL(ADMIN_ORIGIN).hostname ? `${SITE_ORIGIN}${path}` : path
}
